import { render, staticRenderFns } from "./orderReassign.vue?vue&type=template&id=473409b7&scoped=true"
import script from "./orderReassign.vue?vue&type=script&lang=js"
export * from "./orderReassign.vue?vue&type=script&lang=js"
import style0 from "./orderReassign.vue?vue&type=style&index=0&id=473409b7&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473409b7",
  null
  
)

export default component.exports